import { render } from "./HeaderProject.vue?vue&type=template&id=5926bf19"
import script from "./HeaderProject.vue?vue&type=script&lang=js"
export * from "./HeaderProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__